<template>
<div>
    <section>
        <!-- Navigation Header -->
        <div class="top-nav-div">
            <div class="top-nav-elements">
                <a href="#" class="link-block-42 w-inline-block">
                    <img :src="require('@/assets/images/NewSelf_Logo.png')" sizes="(max-width: 479px) 100vw, 84.03125px" loading="lazy" class="image-294">
                </a>
                <div class="form-nav-div">
                    <a href="#" @click.prevent="questionId > 1 ? questionId-- : null" class="back-link w-inline-block">
                        <div class="text-block-507">&lt;-</div>
                    </a>
                    <div class="form-progress-div">
                        <div>
                            <div class="text-block-508">Step <strong>{{ questionId }}</strong> of <strong>{{ totalQuestions }}</strong></div>
                        </div>
                        <div class="form-precent-div">
                            <div class="text-block-509"><strong>{{ Math.round(((questionId - 1) / totalQuestions) * 100) }}%</strong> Complete</div>
                        </div>
                    </div>
                </div>
                <div class="div-block-1442">
                    <div class="text-block-505"></div>
                </div>
            </div>
        </div>
    </section>

    <section class="section-7">
        <div class="questions-div">
            <!-- Sex at Birth -->
            <div class="question-container" v-if="questionId === 1">
                <div class="question-div-2">
                    <div class="text-block-513">What was your sex assigned at birth?</div>
                    <div class="felix-form-block w-form">
                        <div class="div-block-1487">
                            <a href="#" @click.prevent="handleSexSelection('Male')" class="button-68 w-button">Male</a>
                            <a href="#" @click.prevent="handleSexSelection('Female')" class="button-68 w-button">Female</a>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Pregnancy Question (Female Only) -->
            <div class="question-container" v-if="questionId === 2 && formData.sex === 'Female'">
                <div class="question-div-2">
                    <div class="text-block-513">Are you currently pregnant, breastfeeding or planning to become pregnant?</div>
                    <div class="felix-form-block w-form">
                        <div class="div-block-1487">
                            <a href="#" @click.prevent="handlePregnancySelection('Yes')" class="button-68 w-button">Yes</a>
                            <a href="#" @click.prevent="handlePregnancySelection('No')" class="button-68 w-button">No</a>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Pregnancy Consent (Female Only) -->
            <div class="question-container" v-if="questionId === 3 && formData.sex === 'Female' && formData.isPregnant === false">
                <div class="question-div-2">
                    <div class="text-block-513">Pregnancy Consent</div>
                    <div class="consent-text" v-html="pregnancyConsentText"></div>
                    <div class="felix-form-block w-form">
                        <div class="div-block-1487">
                            <a href="#" @click.prevent="handlePregnancyConsent(true)" class="button-68 w-button">I understand and wish to proceed</a>
                            <a href="#" @click.prevent="handlePregnancyConsent(false)" class="button-68 w-button">I do NOT wish to proceed</a>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Height and Weight -->
            <div class="question-container" v-if="questionId === 4">
                <div class="question-div-2">
                    <div class="text-block-513">What is your height and weight?</div>
                    <div class="felix-form-block w-form">
                        <form @submit.prevent="nextQuestion">
                            <div class="div-block-1478 mobile-entry form _2 height top">
                                <input class="text-field-44 height w-input" v-model="formData.height.feet" placeholder="Feet" type="number" required>
                                <input class="text-field-44 height w-input" v-model="formData.height.inches" placeholder="Inches" type="number" required>
                            </div>
                            <div class="div-block-1479 mobile-entry form _2 weight">
                                <input class="text-field-45 weight w-input" v-model="formData.weight" placeholder="Weight in pounds" type="number" required>
                            </div>
                            <input type="submit" class="form-button w-button" value="Next ->">
                        </form>
                    </div>
                </div>
            </div>

            <!-- Medical Conditions -->
            <div class="question-container" v-if="questionId === 5">
                <div class="question-div-2">
                    <div class="text-block-513">Please identify all your current medical conditions</div>
                    <div class="felix-form-block w-form">
                        <form @submit.prevent="nextQuestion">
                            <textarea v-model="formData.medicalConditions" class="text-field-43 w-input" placeholder="List your current medical conditions..." required></textarea>
                            <input type="submit" class="form-button w-button" value="Next ->">
                        </form>
                    </div>
                </div>
            </div>

            <!-- Current Medications -->
            <div class="question-container" v-if="questionId === 6">
                <div class="question-div-2">
                    <div class="text-block-513">Please list all your current medications including dosages</div>
                    <div class="felix-form-block w-form">
                        <form @submit.prevent="nextQuestion">
                            <textarea v-model="formData.medications" class="text-field-43 w-input" placeholder="List medications and dosages..." required></textarea>
                            <input type="submit" class="form-button w-button" value="Next ->">
                        </form>
                    </div>
                </div>
            </div>

            <!-- Allergies -->
            <div class="question-container" v-if="questionId === 7">
                <div class="question-div-2" v-if="!askingAllergy">
                    <div class="text-block-513">Please list all of your known allergies</div>
                    <div class="felix-form-block w-form">
                        <div class="div-block-1487">
                            <a href="#" @click.prevent="askingAllergy=true" class="button-68 w-button">Yes</a>
                            <a href="#" @click.prevent="handleAllergies()" class="button-68 w-button">No</a>
                        </div>
                    </div>
                </div>
                <div class="question-div-2" v-else>
                    <div class="text-block-513">Please list all of your known allergies</div>
                    <div class="felix-form-block w-form">
                        <form @submit.prevent="nextQuestion">
                            <textarea v-model="formData.allergies" class="text-field-43 w-input" placeholder="List any known allergies..." required></textarea>
                            <input type="submit" class="form-button w-button" value="Next ->">
                        </form>
                    </div>
                </div>
            </div>

            <!-- Sexual Desire Level -->
            <div class="question-container" v-if="questionId === 8">
                <div class="question-div-2">
                    <div class="text-block-513">How would you describe your current level of sexual desire?</div>
                    <div class="felix-form-block w-form">
                        <div class="causes-list">
                            <a href="#" @click.prevent="handleDesireLevel('Normal')" class="link-block-30 w-inline-block">
                                <div>
                                    <div class="text-block-545">Normal</div>
                                </div>
                                <div>
                                    <div class="text-block-546">-></div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="handleDesireLevel('Decreased')" class="link-block-30 w-inline-block">
                                <div>
                                    <div class="text-block-545">Decreased</div>
                                </div>
                                <div>
                                    <div class="text-block-546">-></div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="handleDesireLevel('Absent')" class="link-block-30 w-inline-block">
                                <div>
                                    <div class="text-block-545">Absent</div>
                                </div>
                                <div>
                                    <div class="text-block-546">-></div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Duration of Changes -->
            <div class="question-container" v-if="questionId === 9">
                <div class="question-div-2">
                    <div class="text-block-513">How long have you experienced changes in your sexual desire?</div>
                    <div class="felix-form-block w-form">
                        <div class="causes-list">
                            <a href="#" @click.prevent="handleDuration('Less than 3 months')" class="link-block-30 w-inline-block">
                                <div>
                                    <div class="text-block-545">Less than 3 months</div>
                                </div>
                                <div>
                                    <div class="text-block-546">-></div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="handleDuration('3-6 months')" class="link-block-30 w-inline-block">
                                <div>
                                    <div class="text-block-545">3-6 months</div>
                                </div>
                                <div>
                                    <div class="text-block-546">-></div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="handleDuration('More than 6 months')" class="link-block-30 w-inline-block">
                                <div>
                                    <div class="text-block-545">More than 6 months</div>
                                </div>
                                <div>
                                    <div class="text-block-546">-></div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Impact on Relationships -->
            <div class="question-container" v-if="questionId === 10">
                <div class="question-div-2">
                    <div class="text-block-513">Do these changes cause you distress or impact your relationships?</div>
                    <div class="felix-form-block w-form">
                        <div class="div-block-1487">
                            <a href="#" @click.prevent="handleRelationshipImpact('Yes')" class="button-68 w-button">Yes</a>
                            <a href="#" @click.prevent="handleRelationshipImpact('No')" class="button-68 w-button">No</a>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Cause of Decreased Desire -->
            <div class="question-container" v-if="questionId === 11">
                <div class="question-div-2">
                    <div class="text-block-513">Do you believe your decreased sexual desire is due to:</div>
                    <div class="felix-form-block w-form">
                        <div class="causes-list">
                            <a v-for="cause in causes" :key="cause" href="#" @click.prevent="handleCauseSelection(cause)" class="link-block-30 w-inline-block">
                                <div>
                                    <div class="text-block-545">{{ cause }}</div>
                                </div>
                                <div>
                                    <div class="text-block-546">-></div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Other Cause Description -->
            <div class="question-container" v-if="questionId === 12 && formData.cause === 'Other'">
                <div class="question-div-2">
                    <div class="text-block-513">Please describe what you believe your decreased sexual desire is due to</div>
                    <div class="felix-form-block w-form">
                        <form @submit.prevent="nextQuestion">
                            <textarea v-model="formData.otherCauseDescription" class="text-field-43 w-input" placeholder="Please describe..." required></textarea>
                            <input type="submit" class="form-button w-button" value="Next ->">
                        </form>
                    </div>
                </div>
            </div>

            <!-- Previous Treatments -->
            <div class="question-container" v-if="questionId === 13">
                <div class="question-div-2">
                    <div class="text-block-513">Have you tried any treatments for sexual dysfunction before?</div>
                    <div class="felix-form-block w-form">
                        <div class="div-block-1487">
                            <a href="#" @click.prevent="handlePreviousTreatments('Yes')" class="button-68 w-button">Yes</a>
                            <a href="#" @click.prevent="handlePreviousTreatments('No')" class="button-68 w-button">No</a>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Previous Treatment Details -->
            <div class="question-container" v-if="questionId === 14 && formData.previousTreatments === 'Yes'">
                <div class="question-div-2">
                    <div class="text-block-513">Please describe what treatments that you have tried in the past, if they worked or if you have had side effects.</div>
                    <div class="felix-form-block w-form">
                        <form @submit.prevent="nextQuestion">
                            <textarea v-model="formData.treatmentDetails" class="text-field-43 w-input" placeholder="Describe your previous treatments..." required></textarea>
                            <input type="submit" class="form-button w-button" value="Next ->">
                        </form>
                    </div>
                </div>
            </div>

            <!-- Health History Questions -->
            <div class="question-container" v-if="questionId === 15">
                <div class="question-div-2">
                    <div class="text-block-513">Do you have a history of heart disease or stroke?</div>
                    <div class="felix-form-block w-form">
                        <div class="div-block-1487">
                            <a href="#" @click.prevent="handleHeartHistory('Yes')" class="button-68 w-button">Yes</a>
                            <a href="#" @click.prevent="handleHeartHistory('No')" class="button-68 w-button">No</a>
                        </div>
                    </div>
                </div>
            </div>

            <!-- High Blood Pressure -->
            <div class="question-container" v-if="questionId === 16">
                <div class="question-div-2">
                    <div class="text-block-513">Do you have high blood pressure?</div>
                    <div class="felix-form-block w-form">
                        <div class="div-block-1487">
                            <a href="#" @click.prevent="handleBloodPressure('Yes')" class="button-68 w-button">Yes</a>
                            <a href="#" @click.prevent="handleBloodPressure('No')" class="button-68 w-button">No</a>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Blood Pressure Control -->
            <div class="question-container" v-if="questionId === 17 && formData.hasHighBP === 'Yes'">
                <div class="question-div-2">
                    <div class="text-block-513">Is your blood pressure typically well controlled?</div>
                    <div class="felix-form-block w-form">
                        <div class="div-block-1487">
                            <a href="#" @click.prevent="handleBPControl('Yes')" class="button-68 w-button">Yes</a>
                            <a href="#" @click.prevent="handleBPControl('No')" class="button-68 w-button">No</a>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Recent BP Reading -->
            <div class="question-container" v-if="questionId === 18 && formData.hasHighBP === 'Yes' && formData.bpControlled === 'Yes'">
                <div class="question-div-2">
                    <div class="text-block-513">Please provide a recent blood pressure reading taken within the last 4-6 weeks</div>
                    <div class="felix-form-block w-form">
                        <form @submit.prevent="nextQuestion">
                            <textarea v-model="formData.bpReading" class="text-field-43 w-input" placeholder="Enter your blood pressure reading..." required></textarea>
                            <input type="submit" class="form-button w-button" value="Next ->">
                        </form>
                    </div>
                </div>
            </div>

            <!-- Kidney/Liver Disease -->
            <div class="question-container" v-if="questionId === 19">
                <div class="question-div-2">
                    <div class="text-block-513">Do you have advanced kidney or liver disease?</div>
                    <div class="felix-form-block w-form">
                        <div class="div-block-1487">
                            <a href="#" @click.prevent="handleKidneyLiver('Yes')" class="button-68 w-button">Yes</a>
                            <a href="#" @click.prevent="handleKidneyLiver('No')" class="button-68 w-button">No</a>
                        </div>
                    </div>
                </div>
            </div>

            <!-- PT-141 Side Effects -->
            <div class="question-container" v-if="questionId === 20">
                <div class="question-div-2">
                    <div class="text-block-513">Have you ever experienced side effects or an allergic reaction to PT-141?</div>
                    <div class="felix-form-block w-form">
                        <div class="div-block-1487">
                            <a href="#" @click.prevent="handlePT141Reaction('Yes')" class="button-68 w-button">Yes</a>
                            <a href="#" @click.prevent="handlePT141Reaction('No')" class="button-68 w-button">No</a>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Medication Interactions -->
            <div class="question-container" v-if="questionId === 21">
                <div class="question-div-2">
                    <div class="text-block-513">Are you taking any medications that may interact with PT-141 such as indomethacin or naltrexone?</div>
                    <div class="felix-form-block w-form">
                        <div class="div-block-1487">
                            <a href="#" @click.prevent="handleInteractions('Yes')" class="button-68 w-button">Yes</a>
                            <a href="#" @click.prevent="handleInteractions('No')" class="button-68 w-button">No</a>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Specific Medications -->
            <div class="question-container" v-if="questionId === 22 && formData.hasInteractions === 'Yes'">
                <div class="question-div-2">
                    <div class="text-block-513">Do you take indomethacin?</div>
                    <div class="felix-form-block w-form">
                        <div class="div-block-1487">
                            <a href="#" @click.prevent="handleIndomethacin('Yes')" class="button-68 w-button">Yes</a>
                            <a href="#" @click.prevent="handleIndomethacin('No')" class="button-68 w-button">No</a>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Naltrexone -->
            <div class="question-container" v-if="questionId === 23 && formData.hasInteractions === 'Yes'">
                <div class="question-div-2">
                    <div class="text-block-513">Do you take naltrexone?</div>
                    <div class="felix-form-block w-form">
                        <div class="div-block-1487">
                            <a href="#" @click.prevent="handleNaltrexone('Yes')" class="button-68 w-button">Yes - Please note that naltrexone can reduce the effectiveness of this medication</a>
                            <a href="#" @click.prevent="handleNaltrexone('No')" class="button-68 w-button">No</a>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Questions/Concerns -->
            <div class="question-container" v-if="questionId === 24">
                <div class="question-div-2">
                    <div class="text-block-513">Do you have any questions or concerns about using PT-141?</div>
                    <div class="felix-form-block w-form">
                        <div class="div-block-1487">
                            <a href="#" @click.prevent="handleConcerns('Yes')" class="button-68 w-button">Yes</a>
                            <a href="#" @click.prevent="handleConcerns('No')" class="button-68 w-button">No</a>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Concerns Details -->
            <div class="question-container" v-if="questionId === 25 && formData.hasConcerns === 'Yes'">
                <div class="question-div-2">
                    <div class="text-block-513">Please provide further information about your questions or concerns</div>
                    <div class="felix-form-block w-form">
                        <form @submit.prevent="nextQuestion">
                            <textarea v-model="formData.concernDetails" class="text-field-43 w-input" placeholder="Describe your concerns..." required></textarea>
                            <input type="submit" class="form-button w-button" value="Next ->">
                        </form>
                    </div>
                </div>
            </div>

            <!-- Final Consent -->
            <div class="question-container" v-if="questionId === 26">
                <div class="question-div-2">
                    <div class="text-block-513">Informed Consent Statement</div>
                    <div class="consent-text" v-html="informedConsentText"></div>
                    <div class="felix-form-block w-form">
                        <form @submit.prevent="handleSubmit">
                            <label class="w-checkbox checkbox-field-15 w-clearfix">
                                <input type="checkbox" v-model="formData.consentAccepted" required class="w-checkbox-input checkbox-11">
                                <span class="checkbox-label-12 w-form-label">I have read and accept the consent form</span>
                            </label>
                            <input type="submit" class="form-button w-button" :value="isSubmitting ? 'Submitting...' : 'Submit'" :disabled="isSubmitDisabled" :class="{ 'opacity-50': isSubmitting }">
                            <div v-if="errorMessage" class="w-form-fail" style="display: block;">
                                {{ errorMessage }}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <div style="height:280px"></div>
</div>
</template>

<script>
export default {
    name: 'PT141Questionnaire',
    data() {
        return {
            baseUrl: process.env.VUE_APP_API_ENDPOINT,
            questionId: 1,
            totalQuestions: 26,
            isSubmitting: false,
            askingAllergy: false,
            errorMessage: '',
            causes: [
                'Relationship issues',
                'Stress or fatigue',
                'Medical conditions',
                'Medications',
                'Psychological factors',
                'Other'
            ],
            formData: {
                sex: '',
                isPregnant: null,
                pregnancyConsentAccepted: null,
                height: {
                    feet: '',
                    inches: ''
                },
                weight: '',
                medicalConditions: '',
                medications: '',
                allergies: '',
                desireLevel: '',
                durationOfChanges: '',
                relationshipImpact: '',
                cause: '',
                otherCauseDescription: '',
                previousTreatments: '',
                treatmentDetails: '',
                heartHistory: '',
                hasHighBP: '',
                bpControlled: '',
                bpReading: '',
                hasKidneyLiver: '',
                hasPT141Reaction: '',
                hasInteractions: '',
                takesIndomethacin: '',
                takesNaltrexone: '',
                hasConcerns: '',
                concernDetails: '',
                consentAccepted: false
            },
            pregnancyConsentText: `I understand that the medication prescribed to me by my healthcare provider may not be safe to take during pregnancy. I acknowledge that taking this medication while pregnant could pose risks to my health and the health of a developing fetus.<br/><br/>I agree to take necessary precautions to avoid becoming pregnant while using this medication, including the use of effective contraception methods as discussed with my healthcare provider.<br/><br/>I understand that I should stop taking this medication before attempting to become pregnant. I agree to consult with my healthcare provider prior to discontinuing the medication and before planning a pregnancy to ensure my safety and well-being.<br/><br/>By selecting  below, I confirm that I have read and understand the information provided above. I consent to proceed with the treatment under these conditions.`,
            informedConsentText: `PT-141, also known as bremelanotide, is a synthetic peptide analogue that functions in the central nervous system. This medication is prescribed to enhance sexual desire in individuals experiencing hypoactive sexual desire disorder (HSDD). While PT-141 is FDA-approved for treating HSDD in premenopausal women, its use in other populations is considered off-label. The purpose of this consent form is to ensure you understand the potential benefits, risks, contraindications, and responsibilities associated with this treatment.<br><br>PT-141 is intended to increase sexual desire by activating specific pathways in the brain involved in sexual response.  It has shown some benefit in improving erectile dysfunction in males as well.  It may help alleviate distress associated with low sexual desire, potentially improving sexual satisfaction and overall quality of life. <br><br>PT-141 is contraindicated in patients with uncontrolled hypertension due to potential increases in blood pressure. It is also contraindicated in individuals with cardiovascular disease, as the medication may exacerbate underlying conditions. Additionally, those with a known hypersensitivity to bremelanotide or any of its components should not use this medication. It is crucial to inform your healthcare provider if you have any of these conditions before starting treatment. <br><br>While using PT-141, you may experience side effects. Common side effects include nausea, especially after the initial dose, flushing, headache, injection site reactions, vomiting, and nasal congestion. Nausea typically occurs within one-hour post-dose and may last approximately two hours, often decreasing with subsequent doses. Serious side effects may involve a transient increase in blood pressure and reduction in heart rate, peaking 2 to 4 hours after dosing and usually returning to baseline within 12 hours. There is also a risk of focal hyperpigmentation, which includes darkening of the face, gums, and breasts. This may occur more frequently in patients with dark skin and with more frequent administration. Allergic reactions are possible and should be reported immediately. <br><br>Cardiovascular concerns are significant with PT-141 use. The medication can cause temporary increases in blood pressure and decreases in heart rate after each dose. Therefore, it is not recommended for patients at high risk for cardiovascular disease and is contraindicated for those with uncontrolled hypertension or established cardiovascular conditions. If you notice darkening of the skin or gums, known as focal hyperpigmentation, consider discontinuing the medication, as this condition may resolve after stopping treatment. PT-141 may also delay gastric emptying, which can reduce the rate and extent of absorption of orally administered medications. This could affect the efficacy of other medications you are taking, particularly those dependent on specific concentration levels for effectiveness, such as certain antibiotics. Monitor the effectiveness of your other oral medications and consult your healthcare provider if you notice any changes. <br><br>To ensure your safety during treatment with PT-141, a baseline assessment will be conducted to evaluate your medical history and current health status. Regular blood pressure monitoring will be required, especially if you have hypertension. Follow-up visits will be scheduled to monitor your progress and address any concerns. It is important to report any side effects or health changes to your healthcare provider immediately. <br><br>Alternative treatments include lifestyle changes such as stress management techniques, improved communication with your partner, and addressing relationship issues. Therapy options include counseling or sex therapy to address psychological factors contributing to decreased sexual desire. Your healthcare provider may also recommend other medications or treatment modalities based on your specific situation. <br><br>You are responsible for adhering to the prescribed dosing instructions carefully and consistently. Inform your healthcare provider of all medications, supplements, and over-the-counter drugs you are taking to prevent potential interactions. Notify your provider immediately of any side effects, especially if they are severe or persistent. Avoid using substances or medications that may interact adversely with PT-141. Be vigilant about any changes in the effectiveness of your other oral medications and report them to your healthcare provider promptly. <br><br>By agreeing below, you acknowledge that you have read and understood the information provided in this consent form. You agree to proceed with PT-141 treatment under the conditions outlined above.`
        }
    },
    computed: {
        isSubmitDisabled() {
            return this.isSubmitting || !this.formData.consentAccepted
        }
    },
    mounted(){
        this.setSexOnUser();
    },
    methods: {
        setSexOnUser(){
            let temp = this.$store.getters.user;
            try{
                this.formData.weight = temp.weight;
                const totalInches = parseInt(temp.height_inch) || 0
                this.formData.height.feet = Math.floor(totalInches / 12)
                this.formData.height.inches = totalInches % 12
            }catch(error){
                console.log("unable to set height and weight")
            }

            if(temp.gender!=null || temp.gender!==''){
                this.handleSexSelection(temp.gender);
            }
        },
        handleSexSelection(sex) {
            this.formData.sex = sex
            if (sex === 'Male') {
                // Skip pregnancy questions for males
                this.questionId = 4
            } else {
                this.nextQuestion()
            }
        },
        handlePregnancySelection(answer) {
            this.formData.isPregnant = answer === 'Yes'
            if (answer === 'Yes') {
                this.disqualify()
            } else {
                this.nextQuestion()
            }
        },
        handlePregnancyConsent(accepted) {
            this.formData.pregnancyConsentAccepted = accepted
            if (!accepted) {
                this.disqualify()
            } else {
                this.nextQuestion()
            }
        },
        nextQuestion() {
            try {
                // Validate current question before proceeding
                this.validateCurrentQuestion()

                // Specific validation for certain questions
                if (this.questionId === 4) { // Height/Weight question
                    if (!this.validateHeight() || !this.validateWeight()) {
                        throw new Error('Please enter valid height and weight measurements')
                    }
                }

                // If validation passes, proceed to next question
                if (this.questionId < this.totalQuestions) {
                    this.questionId++
                }
            } catch (error) {
                this.handleValidationError(error)
            }
        },
        validateCurrentQuestion() {
            switch (this.questionId) {
                case 4: // Height/Weight
                    if (!this.formData.height.feet || !this.formData.height.inches || !this.formData.weight) {
                        throw new Error('Please complete all measurements')
                    }
                    break
                case 5: // Medical Conditions
                    if (!this.formData.medicalConditions.trim()) {
                        throw new Error('Please enter your medical conditions or "None" if not applicable')
                    }
                    break
                case 6: // Medications
                    if (!this.formData.medications.trim()) {
                        throw new Error('Please enter your medications or "None" if not applicable')
                    }
                    break
                case 7: // Allergies
                    if (!this.formData.allergies.trim()) {
                        throw new Error('Please enter your allergies or "None" if not applicable')
                    }
                    break
                    // Add validation for other questions as needed
            }
        },
        handleDesireLevel(level) {
            this.formData.desireLevel = level
            this.nextQuestion()
        },
        handleDuration(duration) {
            this.formData.durationOfChanges = duration
            this.nextQuestion()
        },
        handleRelationshipImpact(impact) {
            this.formData.relationshipImpact = impact
            this.nextQuestion()
        },
        handleCauseSelection(cause) {
            this.formData.cause = cause
            if (cause === 'Other') {
                this.nextQuestion()
            } else {
                this.questionId += 2 // Skip the "Other" description question
            }
        },
        handlePreviousTreatments(answer) {
            this.formData.previousTreatments = answer
            if (answer === 'No') {
                this.questionId += 2 // Skip treatment details
            } else {
                this.nextQuestion()
            }
        },
        handleHeartHistory(answer) {
            this.formData.heartHistory = answer
            if (answer === 'Yes') {
                this.disqualify()
            } else {
                this.nextQuestion()
            }
        },
        handleAllergies(){
            this.formData.allergies= "None",
            this.nextQuestion();
        },
        handleBloodPressure(answer) {
            this.formData.hasHighBP = answer
            if (answer === 'No') {
                this.questionId += 3 // Skip BP control and reading questions
            } else {
                this.nextQuestion()
            }
        },
        handleBPControl(answer) {
            this.formData.bpControlled = answer
            if (answer === 'No') {
                this.disqualify()
            } else {
                this.nextQuestion()
            }
        },
        handleKidneyLiver(answer) {
            this.formData.hasKidneyLiver = answer
            if (answer === 'Yes') {
                this.disqualify()
            } else {
                this.nextQuestion()
            }
        },
        handlePT141Reaction(answer) {
            this.formData.hasPT141Reaction = answer
            if (answer === 'Yes') {
                this.disqualify()
            } else {
                this.nextQuestion()
            }
        },
        handleInteractions(answer) {
            this.formData.hasInteractions = answer
            if (answer === 'No') {
                this.questionId += 3 // Skip specific medication questions
            } else {
                this.nextQuestion()
            }
        },
        handleIndomethacin(answer) {
            this.formData.takesIndomethacin = answer
            if (answer === 'Yes') {
                this.disqualify()
            } else {
                this.nextQuestion()
            }
        },
        handleNaltrexone(answer) {
            this.formData.takesNaltrexone = answer
            this.nextQuestion()
        },
        handleConcerns(answer) {
            this.formData.hasConcerns = answer
            if (answer === 'No') {
                this.questionId += 2 // Skip concerns details
            } else {
                this.nextQuestion()
            }
        },
        disqualify() {
            // Handle disqualification - redirect to disqualification page
            this.$router.push('/sorry')
        },
        async handleSubmit() {
            if (!this.formData.consentAccepted) {
                this.handleValidationError(new Error('Please accept the consent form to continue'))
                return
            }

            // Validate form before submission
            if (!this.validateForm()) {
                return
            }

            try {
                const formattedData = {
                    formObj: this.formatQuestionsAndAnswers(),
                    patientInfo: {
                        sex: this.formData.sex,
                        height: `${this.formData.height.feet}'${this.formData.height.inches}"`,
                        weight: this.formData.weight,
                        medicalConditions: this.formData.medicalConditions,
                        currentMedications: this.formData.medications,
                        allergies: this.formData.allergies
                    },
                    pharmacyId: "",
                    masterId: `visit_${Date.now()}`,
                    company: "newSelf",
                    visitType: "pt141"
                }

                // Show loading state
                this.isSubmitting = true

                const response = await this.$axios.post(`${this.baseUrl}/forms/assessment-form/pt141/${this.$route.params.id}`, formattedData)

                if (response.data.status === 'success') {
                    this.$router.push('/success')
                } else {
                    throw new Error(response.data.message || 'Form submission failed')
                }
            } catch (error) {
                const errorMessage = error.response?.data?.message || error.message || 'An error occurred while submitting the form'
                this.handleValidationError(new Error(errorMessage))
            } finally {
                this.isSubmitting = false
            }
        },
        formatQuestionsAndAnswers() {
            return {
                Q1: "What was your sex assigned at birth? Available Options: Male, Female",
                A1: this.formData.sex,

                Q2: "Are you currently pregnant, breastfeeding or planning to become pregnant? Available Options: Yes, No",
                A2: this.formData.sex === 'Female' ? (this.formData.isPregnant ? 'Yes' : 'No') : 'N/A',

                Q3: "Pregnancy Consent. Available Options: I have read and understand the above information, I understand the risks and wish to proceed, I have read the information and do NOT wish to proceed",
                A3: this.formData.sex === 'Female' ? (this.formData.pregnancyConsentAccepted ? 'I have read and understand the above information, I understand the risks and wish to proceed' : 'I have read the information and do NOT wish to proceed') : 'N/A',

                Q4: "What is your height and weight? Format: Height in feet and inches, Weight in pounds",
                A4: `Height: ${this.formData.height.feet}'${this.formData.height.inches}", Weight: ${this.formData.weight} lbs`,

                Q5: "Please identify all your current medical conditions. Format: Free text",
                A5: this.formData.medicalConditions || "None reported",

                Q6: "Please list all your current medications including dosages. Format: Free text",
                A6: this.formData.medications || "None reported",

                Q7: "Please list all of your known allergies. Format: Free text",
                A7: this.formData.allergies || "None reported",

                Q8: "How would you describe your current level of sexual desire? Available Options: Normal, Decreased, Absent",
                A8: this.formData.desireLevel,

                Q9: "How long have you experienced changes in your sexual desire? Available Options: Less than 3 months, 3-6 months, More than 6 months",
                A9: this.formData.durationOfChanges,

                Q10: "Do these changes cause you distress or impact your relationships? Available Options: Yes, No",
                A10: this.formData.relationshipImpact,

                Q11: "Do you believe your decreased sexual desire is due to: Available Options: Relationship issues, Stress or fatigue, Medical conditions, Medications, Psychological factors, Other",
                A11: this.formData.cause,

                Q12: "Please describe what you believe your decreased sexual desire is due to. Format: Free text",
                A12: this.formData.cause === 'Other' ? this.formData.otherCauseDescription : 'N/A',

                Q13: "Have you tried any treatments for sexual dysfunction before? Available Options: Yes, No",
                A13: this.formData.previousTreatments,

                Q14: "Please describe what treatments that you have tried in the past, if they worked or if you have had side effects. Format: Free text",
                A14: this.formData.previousTreatments === 'Yes' ? this.formData.treatmentDetails : 'N/A',

                Q15: "Do you have a history of heart disease or stroke? Available Options: Yes, No",
                A15: this.formData.heartHistory,

                Q16: "Do you have high blood pressure? Available Options: Yes, No",
                A16: this.formData.hasHighBP,

                Q17: "Is your blood pressure typically well controlled? Available Options: Yes, No",
                A17: this.formData.hasHighBP === 'Yes' ? this.formData.bpControlled : 'N/A',

                Q18: "Please provide a recent blood pressure reading taken within the last 4-6 weeks. Format: Free text",
                A18: this.formData.hasHighBP === 'Yes' && this.formData.bpControlled === 'Yes' ?
                    this.formData.bpReading : 'N/A',

                Q19: "Do you have advanced kidney or liver disease? Available Options: Yes, No",
                A19: this.formData.hasKidneyLiver,

                Q20: "Have you ever experienced side effects or an allergic reaction to PT-141? Available Options: Yes, No",
                A20: this.formData.hasPT141Reaction,

                Q21: "Are you taking any medications that may interact with PT-141 such as indomethacin or naltrexone? Available Options: Yes, No",
                A21: this.formData.hasInteractions,

                Q22: "Do you take indomethacin? Available Options: Yes, No",
                A22: this.formData.hasInteractions === 'Yes' ? this.formData.takesIndomethacin : 'N/A',

                Q23: "Do you take naltrexone? Available Options: Yes - Please note that naltrexone can reduce the effectiveness of this medication, No",
                A23: this.formData.hasInteractions === 'Yes' ? this.formData.takesNaltrexone : 'N/A',

                Q24: "Do you have any questions or concerns about using PT-141? Available Options: Yes, No",
                A24: this.formData.hasConcerns,

                Q25: "Please provide further information about your questions or concerns. Format: Free text",
                A25: this.formData.hasConcerns === 'Yes' ? this.formData.concernDetails : 'N/A',

                Q26: "Informed Consent. Available Options: I have read the above information, understand the risks, and wish to proceed, I have read the above information and do NOT wish to proceed",
                A26: this.formData.consentAccepted ? "I have read the above information, understand the risks, and wish to proceed" : "I have read the above information and do NOT wish to proceed"
            }
        },
        validateForm() {
            try {
                // Basic validation checks
                if (!this.formData.sex) {
                    throw new Error('Sex is required')
                }

                if (!this.validateHeight()) {
                    throw new Error('Please enter a valid height (4-8 feet, 0-11 inches)')
                }

                if (!this.validateWeight()) {
                    throw new Error('Please enter a valid weight (50-500 pounds)')
                }

                if (this.formData.cause === 'Other' && !this.formData.otherCauseDescription) {
                    throw new Error('Please specify other cause')
                }

                return true
            } catch (error) {
                this.handleValidationError(error)
                return false
            }
        },
        handleValidationError(error) {
            // Show error to user
            this.$toast?.error(error.message) || alert(error.message)
            console.error('Validation error:', error)
        },
        validateHeight() {
            const feet = parseInt(this.formData.height.feet)
            const inches = parseInt(this.formData.height.inches)
            return (
                !isNaN(feet) &&
                !isNaN(inches) &&
                feet >= 4 &&
                feet <= 8 &&
                inches >= 0 &&
                inches <= 11
            )
        },
        validateWeight() {
            const weight = parseInt(this.formData.weight)
            return !isNaN(weight) && weight >= 50 && weight <= 500
        }
    },
    watch: {
        questionId() {
            // Scroll to top when question changes
            window.scrollTo(0, 0)
        }
    }
}
</script>

<style scoped>
</style>
